<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">User Profile</span>
            </v-card-title>
            <v-switch v-model="newUser" flat label="Add New User"></v-switch>
            <v-card-text>
                <v-container v-if="newUser===true">
                    <v-card-title>Add New User</v-card-title>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="userData.displayName" label="Display Name*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="userData.email" label="Email*" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                        <v-text-field v-model="userData.password" label="Password*" type="password" required></v-text-field>
                        </v-col>
                    </v-row>
                    <small>*indicates required field</small>
                </v-container>
                <v-container v-if="newUser===false">
                    <v-card-title>Add Existing User</v-card-title>
                    <v-row>
                        <!-- Add in some existing user search here -->
                        <v-col cols="12" sm="9" md="9">
                            <v-text-field v-model="existingUserData.email" label="Enter the email of the existing user you wish to add*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-switch v-model="existingUserData.admin" flat label="Admin?"></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary"
                :disabled="loading" 
                text @click="closeDialog()">Close</v-btn>
                <v-btn color="primary" 
                :loading="loading"
                :disabled="loading" 
                text @click="addUser()">Add User to Organisation</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>

export default {
    name: 'addUserPopup',
    components: {
        
    },
    props: {
        loading: Boolean
    },
    mounted(){
    },
    methods: {   
        addUser(){
            if (this.newUser){
                //If it is a new user that has been created, emit this event out
                this.$emit("addNewUser", this.userData);
            } else {
                //Otherwise, just add an existing user with the data we have searched (pass back a uid?)
                this.$emit("addExistingUser", this.existingUserData);
            }
        },
        closeDialog(){
            this.$emit("dialogClosed");
        }
    },
    data: () => ({
        newUser: false, //can be new or existing
        userData: {
            email: "",
            password: "",
            displayName: "",
            photoURL: "https://cdn.business2community.com/wp-content/uploads/2017/08/blank-profile-picture-973460_640.png"
        },
        existingUserData: {
            email: "",
            orgid: "",
            admin: false
        }
    })    
}
</script>